import { Alert, Box, Button, SpaceBetween } from '@cloudscape-design/components';

/**
 * Terminal screen shown when an authenticated identity's email domain is not in the
 * allowlist (VITE_ALLOWED_EMAIL_DOMAINS). Rendered by AuthProvider INSTEAD of the app so a
 * disallowed user can't reach any route. This is a UX/defense-in-depth layer — the
 * authoritative domain enforcement must live server-side (see the auth plan).
 */
export default function AccessRestricted({
  email,
  onSignOut,
}: {
  email: string;
  onSignOut: () => void;
}) {
  return (
    <Box margin={{ top: 'xxxl' }} padding="xxl" textAlign="center">
      <SpaceBetween size="l">
        <Alert type="error" header="Access restricted">
          Sign-in is limited to authorized Deloitte accounts. The account{' '}
          <strong>{email || 'you signed in with'}</strong> is not permitted to access this
          platform. If you believe this is a mistake, contact the platform administrator.
        </Alert>
        <Box textAlign="center">
          <Button variant="primary" onClick={onSignOut}>
            Sign out
          </Button>
        </Box>
      </SpaceBetween>
    </Box>
  );
}
